import image1 from'./Images/Portifolio Image.png'


export  const Preview =[
    {
        id:1,
        image:image1,
                },
    
]
